/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid container">
   {{#products}} 
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor" data-variant-id="{{epi}}">
     <div>
       <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
         <span class="font-icon">
         </span>
       </button>
       <div class="swym-wishlist-image-wrapper">
         <img alt="" class="swym-wishlist-image" src="{{iu}}">
       </div>
    
       <div class="swym-vendor swym-vendor-1"></div>
    
       <button class="swym-is-button">
         <div class="swym-title swym-title-1">
           {{dt}}
         </div>
       </button>
    
       <div class="swym-variant-title swym-text swym-title-2 swym-variant-title-spacer">
         {{variantinfo}}
       </div>
       
       <div class="swym-product-price swym-text swym-text-1">
         <div class="swym-product-final-price swym-value">
           {{cu}}{{pr}}
         </div>
       </div>
     </div>
     
     <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
       {{#isInCart}}Hinzugefügt{{/isInCart}}{{^isInCart}}In den Warenkorb{{/isInCart}}
     </button>
   </a>
   
   {{/products}}
</div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys =
        variants && variants != "[]"
          ? Object.keys(JSON.parse(variants)[0])
          : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute("data-product-id");
  var variantId = e.currentTarget.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-product-url");
  e.target.innerHTML = "Wird hinzugefügt..";

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
  })
    .then((response) => {
      location.reload();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function getSizeOption(product) {
  for (let i = 0; i < 3; i++) {
    if (
      product.options[i].name == "Size" ||
      product.options[i].name == "Größe"
    ) {
      let name = "option" + (i + 1);
      return name;
    }
  }
}

function buildPrice(p, variant) {
  let html = "";
  let price = (parseInt(variant.price.replace(".", "")) / 100).toFixed(2);
  let compare_at_price = (
    parseInt(variant.compare_at_price.replace(".", "")) / 100
  ).toFixed(2);
  let price_comma = price.replace(".", ",");
  let compare_at_price_comma = compare_at_price.replace(".", ",");
  let savings = (compare_at_price - price).toFixed(2).replace(".", ",");
  if (variant.compare_at_price > variant.price) {
    html = `<span class="price--sale"><span class="price--final">${price_comma} ${p.cu}</span><span class="price--compare">${compare_at_price_comma} ${p.cu}</span></span><span class="price--savings">Du sparst ${savings} ${p.cu}</span>`;
  } else {
    html = `<span class="price--final"s>${price_comma} ${p.cu}</span>`;
  }

  return html;
}

async function additionalInfo(p) {
  let data = await fetch(`${p.du}.json`)
    .then((res) => res.json())
    .then((data) => {
      let myProduct = data.product;
      let myVariant = myProduct.variants.find((variant) => variant.id == p.epi);
      let sizeOption = getSizeOption(myProduct);
      let myPrice = buildPrice(p, myVariant);

      console.log(myProduct);
      console.log(myVariant);

      document.querySelector(
        `[data-variant-id="${myVariant.id}"] .swym-vendor`
      ).innerText = myProduct.vendor;
      document.querySelector(
        `[data-variant-id="${myVariant.id}"] .swym-variant-title`
      ).innerText = "Größe: " + myVariant[sizeOption];
      document.querySelector(
        `[data-variant-id="${myVariant.id}"] .swym-product-final-price`
      ).innerHTML = myPrice;
    });
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute("data-variant-id");
  var empi = +e.currentTarget.getAttribute("data-product-id");
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    var wishlistContentsContainer = document.getElementById(
      "wishlist-items-container"
    );
    var formattedWishlistedProducts = products.map(function (p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart =
        _swat.platform.isInDeviceCart(p.epi) ||
        p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : "";

      additionalInfo(p);

      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else {
      console.log("Container not found, Wishlist Page element not found");
    }
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll(
    "#swym-custom-add-toCartBtn"
  );
  var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener("click", onRemoveBtnClick, false);
  }
  console.log("Events attached!");
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */